@if (schema()) {
  <apx-chart
    #chart
    class="chart"
    [legend]="schema().legend"
    [series]="schema().series"
    [stroke]="$any(schema().stroke)"
    [forecastDataPoints]="schema().forecastDataPoints"
    [chart]="$any(schema().chart)"
    [dataLabels]="schema().dataLabels"
    [yaxis]="schema().yaxis"
    [xaxis]="schema().xaxis"
    [annotations]="schema().annotations"
    [colors]="schema().colors"
    [labels]="schema().labels"
    [markers]="$any(schema().markers)"
    [noData]="schema().noData"
    [fill]="schema().fill"
    [tooltip]="schema().tooltip"
    [plotOptions]="$any(schema().plotOptions)"
    [responsive]="schema().responsive"
    [grid]="schema().grid"
    [states]="schema().states"
    [title]="schema().title"
    [subtitle]="schema().subtitle"
    [theme]="schema().theme"
    (chartReady)="chartReady()"
    (updated)="chartReady()"
  ></apx-chart>
  <img class="image" [src]="imgURI()" />
}
